import { 
    ofType, 
    ActionsObservable 
} from 'redux-observable';
import { 
    map, 
    mergeMap, 
    flatMap 
} from 'rxjs/operators';
import { from } from 'rxjs';

import axios from 'axios';

import { format } from 'one-util-date';


import { 
    Skeleton, 
    Disposition 
} from 'one-model-local';
import { addAction } from 'one-state-error/src/actions';
import { ErrorObject } from 'one-state-error/src/errorobject';
import { setNotificationAction } from 'one-state-errorhandle';
import { setAction as setSkeletonAction } from 'one-state-skeleton';
import {
    addAction as addSubjectAction,
    setSelectedAthenaAction
} from 'one-state-subject/src/actions';
import {
    selectAction as sourceSelectAction,
    addAction as sourceAddAction,
    setAction as setSource
} from 'one-state-source-local';

import { setAction as lookupErrorSet } from "one-state-subjecterror/src/action";

import { TransformResponse } from './transform';

export const enum Types {
    GetSubjects = 'caller-patient-athena',
    PushtoSubject = 'one-state-subject/set',
    GetDrawer = 'one-patient-drawer/set',
    HEALTHALERT = 'healthAlert',
    ConsolidateAPIOne = 'consolidated-api-one',
    SETCALLERDBDETAILS = 'one-state-source/set',
    STORE_DISPOSITION_CODE = "store-disposition-code",
}

const pushToSubject = (payload: any) => ({ type: Types.PushtoSubject, payload });
const pushToDrawer = (payload: any) => ({ type: Types.GetDrawer, payload });
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });

/**
 * This Fuction will fetch the data form Athena Patient Lookup API
 * from backend api and returns the response and calls
 * subsequent redux action
 * @param context contains the settings etc..
 */
export const fetchPatientsAthena = (context: any) => (
    (action$: any, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server, log, agentId,teamName, alertnotification, settings: { compatible, athenaendpoints: { getpatientathena } } } = context;
        const { contact_center_type } = compatible;

        return action$.pipe(
            ofType(Types.GetSubjects),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient response
                 */
                const dataresponse: any = action.payload;
                let data:any = {}
                const getRequest = (reqresponse: any) => {
                    let respreturn;
                    if (reqresponse) {
                        let headers = new Headers();
                        headers.append("Accept", "application/json");
                        headers.append("Content-Type", "text/plain");
                        if(contact_center_type === "finesse") {
                            if (reqresponse.number && reqresponse.subjectid) {
                                data = {
                                    "PhoneNumber": reqresponse.number,
                                    "PatientName": "",
                                    "DateOfBirth": "",
                                }
                            }
                            else if(reqresponse.subjectid) {
                                data = {
                                    "PatientID": reqresponse.subjectid
                                }
                            }
                            else if(reqresponse.sourceid) {
                                data = {
                                    "PatientID": reqresponse.sourceid 
                                }
                            }
                            else {
                                data = {
                                    "PhoneNumber": reqresponse.number ? reqresponse.number : "",
                                    "PatientName": "",
                                    "DateOfBirth": "",
                                }
                            } 
                        }
                        else if(contact_center_type === "vonage" || contact_center_type === "wxcc" || contact_center_type === "five9" || contact_center_type==="twilio" || contact_center_type === 'genesys' || contact_center_type === 'inContact') {
                            // data = {
                            //     "PhoneNumber": reqresponse.number ? reqresponse.number : "",
                            // }
                            if(reqresponse.subjectid) {
                                data = {
                                    "PatientID": reqresponse.subjectid
                                }
                            }
                            else if(reqresponse.sourceid) {
                                data = {
                                    "PatientID": reqresponse.sourceid 
                                }
                            }
                            else {
                                data = {
                                    "PhoneNumber": reqresponse.number ? reqresponse.number : "",
                                    "PatientName": "",
                                    "DateOfBirth": "",
                                }
                            }
                        }
                        const response = server.post({
                            path: getpatientathena,
                            data: data,
                            headers: headers
                        })
                            .then((resp: any) => resp)
                            .catch((responseerror: any) => {
                                log.error("one-epic", "patientEpic Error", responseerror);
                                // SEND to ALERT notificaiton/NOC servers for critical error on no active server
                                if (responseerror?.status === 0) {
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseerror
                                        });
                                    }
                                }
                                let error = [
                                {
                                    "error_code": 32001,
                                    "error_type": "Bad Gateway Error",
                                    "display_text": "Oops! An error occured. Please contact your administrator",
                                    "http_code": "504",
                                    "error_description": "",
                                    "error_detail": "",
                                    "audit_log": {
                                        "channel": "Patient Lookup",
                                        "timestamp": "2023-09-07T06:25:39.982Z",
                                        "message_id": 34058
                                    }
                                }
                                ]
                                let subjecterror: ErrorObject = {}
                                if(responseerror.status === undefined) {
                                    subjecterror = {
                                        source: "Subject",
                                        type: "error",
                                        status: 502,
                                        erroritems: error,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    if (alertnotification?.isEnabled()) {
                                        var timestamp = new Date().toJSON();
                                        alertnotification.notify({
                                            "error_code": "930-31",
                                            "error_type": "SERVER_ERROR",
                                            "error_description": "Unable to reach active servers",
                                            "error_supertype": "SERVER_FAILS",
                                            "error_detail": "Unable to reach any of server for retring data ",
                                            "alert": "Yes",
                                            "timestamp": timestamp,
                                            "params": responseerror
                                        });
                                    }
                                }
                                else if(responseerror?.status) {
                                    subjecterror = {
                                        source: "Subject",
                                        type: "error",
                                        status: responseerror?.status,
                                        erroritems: responseerror?.errors,
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                }
                                return subjecterror;
                            })
                        respreturn = from(response);
                    } else {
                        respreturn = from([]);
                    }
                    log.debug("one-epic", "patientEpic response", respreturn);
                    return respreturn;
                }
                return getRequest(dataresponse).
                    pipe(
                        map(response => TransformResponse(response, context, dataresponse.number))).
                    pipe(
                        flatMap((response: any) => {
                            const actions: any = [
                                pushToSubject(response.subjectdata)
                            ];
                            //For Subject
                            const selected = response.subjectdata.find(
                                (item: any) => item.id === dataresponse.subjectid
                            );
                            if (selected && 'id' in selected) {
                                actions.push(setSelectedAthenaAction(selected));
                            }
                            //For Source
                            const sourceselected = response.subjectdata.find(
                                (item: any) => item.id === dataresponse.sourceid
                            );
                            if (sourceselected && 'id' in sourceselected) {
                                actions.push(sourceAddAction(sourceselected));
                                actions.push(sourceSelectAction(sourceselected.id));
                                //Making skeleton to false
                                let skeletonsource: Skeleton = {
                                    source_skeleton: false
                                }
                            actions.push(pushToSkeleton(skeletonsource));
                            }
                            //Making skeleton to false
                            let skeletonsource: Skeleton = {
                                subject_skeleton: false
                            }
                            actions.push(pushToSkeleton(skeletonsource));
                            // check for error messages.
                            if (response.error) {
                                actions.push(addAction(response.error));
                                //To store the error object in the reducer.
                                actions.push(lookupErrorSet(response.error));
                                let disp: Disposition = { value: "997" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = response.error.status;
                                disp.meta03 = response.error.erroritems?.[0]?.error_detail;
                                disp.meta04 = 'client';
                                actions.push(pushToDisposition(disp));
                            } else {
                                let disp: Disposition = { value: "180" }
                                if (contact_center_type && contact_center_type === 'five9') {
                                    let agentIdValue = sessionStorage.getItem("agentName");
                                    let skillName = sessionStorage.getItem("skillName");
                                    disp.meta00 = agentIdValue;
                                    disp.meta01 = skillName;
                                    disp.dial_list_uid = state$.value?.five9Interaction?.interactionId;
                                } else {
                                    disp.meta00 = agentId;
                                    disp.meta01 = teamName;
                                    disp.dial_list_uid = state$.value?.choosecaller?.callId;
                                }
                                disp.meta02 = '200';
                                disp.meta03 = 'client';
                                actions.push(pushToDisposition(disp));
                            }
                            return actions;
                        })
                    )
            })
        )
    }
);

export const selectDrawer = (context: any) => (
    (action$: ActionsObservable<any>) => {
        return action$.pipe(
            ofType(Types.PushtoSubject),
            map(action => pushToDrawer(true)),
        )
    }
);

export const healthAlert = (context: any) => (
    (action$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings
        } = context;
        return action$.pipe(
            ofType(Types.HEALTHALERT),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the employee request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "healthAlert request", dataresponse);
                const healthAlertCall = (payload: any) => {
                    const { servers } = settings;
                    const { locations = [] } = servers;
                    const healthCheck = locations[0]?.base+"epic/v1/healthcheck";
                    log.debug('healthcheck ', 'API', healthCheck);
                    const resp = axios.get(`${healthCheck}`)
                    .then((response: any) => {
                        log.debug('HEALTH CHECK SUCCESS: ', 'Agenta health check passed with status code:', response)
                        return response;
                    })
                    .catch((response: any) => {
                        //Check the Side B server healthcheck
                        if(locations.length >= 2){
                            const healthCheckTwo = locations[1]?.base+"epic/v1/healthcheck";
                            const resptwo = axios.get(`${healthCheckTwo}`)
                            .then((response: any) => {
                                log.debug('HEALTH CHECK SUCCESS: ', 'Agenta health check passed with status code:', response)
                                return response;
                            })
                            .catch((response: any) => {
                                if(payload?.agentId) {
                                    log.debug('healthAlert ', 'Response', response);
                                    let alerterror: ErrorObject = {
                                        source: healthCheck,
                                        type: "error",
                                        status: 400,
                                        erroritems: [],
                                        error_date: errorDate,
                                        error_time: errorTime
                                    };
                                    
                                    // A brief description on how you can troubleshoot our two common errors seen here.
                                    console.error('HEALTH CHECK ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                    return alerterror;
                                }
                            });
                            return resptwo;
                        }else{
                            if(payload?.agentId) {
                                log.debug('healthAlert ', 'Response', response);
                                let alerterror: ErrorObject = {
                                    source: healthCheck,
                                    type: "error",
                                    status: 400,
                                    erroritems: [],
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                
                                // A brief description on how you can troubleshoot our two common errors seen here.
                                console.error('HEALTH CHECK ERROR: Unable to reach the Agenta server. If cert error (\'ERR_CERT_AUTHORITY_INVALID\'), browse the request URL and accept the certificate. If \'ERR_NAME_NOT_RESOLVED\', verify connection to UPMC server environment.');
                                return alerterror;
                            }
                        }
                    });
                    //log.debug("one-epics", "Cherwell response", response);
                    return from(resp);
                }
                return healthAlertCall(dataresponse).pipe(
                    flatMap((response: any) => {
                        log.debug('healthAlert ','Response::', response);
                        const actions: any = [];
                        if (response && response.type && response.type === 'error') {
                            actions.push(setNotificationAction({
                                healthCheckUrl: response.source,
                                notifiy: true
                            }))
                        }
                        return actions;
                    })
                )
            })
        )
    }
);
